import type { AppError, DisposableBattle } from './app-error';
import { disposeFatalBattle } from './app-error';

export class FatalErrorController {
  private battle: DisposableBattle | null = null; private clearTransients: () => void = () => undefined;
  private readonly reload: () => void;
  public constructor(private readonly gameElement: HTMLElement, private readonly fatalElement: HTMLElement, reload: () => void = () => globalThis.location.reload()) {
    this.reload = reload;
  }
  public registerBattle(battle: DisposableBattle | null, clearTransients: () => void = () => undefined): void {
    this.battle = battle; this.clearTransients = clearTransients;
  }
  public show(error: AppError): void {
    disposeFatalBattle(this.battle, this.clearTransients); this.battle = null; this.clearTransients = () => undefined;
    this.gameElement.style.display = 'none'; this.fatalElement.style.display = 'grid';
    this.fatalElement.replaceChildren();
    const title = document.createElement('h1'); title.textContent = 'OFFICE CLASH — Fatal Error';
    const detail = document.createElement('p'); detail.textContent = `${error.category}: ${error.message}`;
    const button = document.createElement('button'); button.type = 'button'; button.textContent = 'Reload'; button.addEventListener('click', this.reload, { once: true });
    this.fatalElement.append(title, detail, button);
  }
}
